module.exports = __webpack_public_path__ + "static/media/farmacia-200x200.5438b416.png";